/**
 * Created by shiyonggao on 2019/2/25.
 */

/**
 * state 中的方法命名规则（小驼峰规则）
 */
const state = {
    iosConfigList: [],
    androidConfigList: [],
    h5ConfigList: [],
    windowsConfigList: [],
    sdkVersion: [],
    iosSdkVersion: [],
    androidSdkVersion: [],
    h5SdkVersion: [],
    windowsSdkVersion: [],
    iosPackageList: [],
    androidPackageList: [],
    h5PackageList: [],
    windowsPackageList: [],
    iosGameVersion: [],
    androidGameVersion: [],
    h5GameVersion: [],
    windowsGameVersion: [],
};

/**
 * actions 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 */
const actions = {
    GET_SDK_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        rootState.$helper.request.get('/sdk/' + args.platform + '/versions', {}).then(
            function (res) {
                data = res.data.sdk_versions;
                if (args.platform === 'IOS') {
                    commit('_iosSdkVersion', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5SdkVersion', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsSdkVersion', data);
                }
                else {
                    commit('_androidSdkVersion', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },

    GET_GAME_VERSION ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getgameversion', {game_code: gameCode}).then(
            function (res) {
                data = res.data.result;
                if (args.platform === 'IOS') {
                    commit('_iosGameVersion', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5GameVersion', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsGameVersion', data);
                }
                else {
                    commit('_androidGameVersion', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_PACKAGE_LIST ({state, commit, dispatch, rootState}, args) {
        let data = [];
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        rootState.$helper.request.get('/ajaxrela/getpackagenameregionlist', {
            game_code: gameCode,
            platform: args.platform
        }).then(
            function (res) {
                data = res.data.result;
                if (args.platform === 'IOS') {
                    commit('_iosPackageList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5PackageList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsPackageList', data);
                }
                else {
                    commit('_androidPackageList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    GET_CONFIG_LIST ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.get('/games/' + gameCode + '/releases',
            {
                platform: args.platform,
                package_id: args.package_id,
                sdk_version: args.sdk_version,
                game_version: args.game_version,
            }).then(
            function (res) {
                data = res.data.releases;
                if (args.platform === 'IOS') {
                    commit('_iosConfigList', data);
                }
                else if (args.platform === 'H5') {
                    commit('_h5ConfigList', data);
                }
                else if (args.platform === 'WINDOWS') {
                    commit('_windowsConfigList', data);
                }
                else {
                    commit('_androidCongfigList', data);
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    },
    DELETE_ROW ({state, commit, dispatch, rootState}, args) {
        let gameCode = rootState.$helper.helper.getGameCode().game_code;
        let data = [];
        rootState.$helper.request.delete('/games/' + gameCode + '/releases/' + args.release_id, {platform: args.platform}).then(
            function (res) {
                data = res.data.deleted;
                if (data) {
                    dispatch('ALERT_HANDLE', {
                        message: '删除成功!',
                        callback () {
                            rootState.$helper.helper.route('sdk/releaseslist', {platform: args.platform});
                        }
                    }, {root: true});
                }
                else {
                    dispatch('ALERT_HANDLE', {
                        message: '删除失败!',
                        callback () {
                            rootState.$helper.helper.route('sdk/releaseslist');
                        }
                    }, {root: true});
                }
            }
        ).catch(function (res) {
            dispatch('ERROR_HANDLE', res, {root: true});
        });
    }
};

/**
 * getters 中的方法命名规则（外部调用）
 * 外部调用：DEMO
 */
const getters = {};

/**
 * mutations 中的方法命名规则（外部调用和内部调用）
 * 内部规则：_demo
 * 外部调用：DEMO
 * 描述：建议不对外提供映射关系
 */
const mutations = {
    _iosConfigList (state, args) {
        state.iosConfigList = args;
        console.log('_iosConfigList=', state.iosConfigList);
    },
    _androidCongfigList (state, args) {
        state.androidConfigList = args;
        console.log('_androidCongfigList=', state.androidConfigList);
    },
    _h5ConfigList (state, args) {
        state.h5ConfigList = args;
        console.log('_h5CongfigList=', state.h5ConfigList);
    },
    _windowsConfigList (state, args) {
        state.windowsConfigList = args;
        console.log('_windowsCongfigList=', state.windowsConfigList);
    },
    _iosSdkVersion (state, args) {
        state.iosSdkVersion = args;
        console.log('_iosSdkVersion=', state.iosSdkVersion);
    },
    _androidSdkVersion (state, args) {
        state.androidSdkVersion = args;
        console.log('_androidSdkVersion=', state.androidSdkVersion);
    },
    _h5SdkVersion (state, args) {
        state.h5SdkVersion = args;
        console.log('_h5SdkVersion=', state.h5SdkVersion);
    },
    _windowsSdkVersion (state, args) {
        state.windowsSdkVersion = args;
        console.log('_windowsSdkVersion=', state.windowsSdkVersion);
    },
    _iosGameVersion (state, args) {
        state.iosGameVersion = args;
        console.log('_iosGameVersion=', state.iosGameVersion);
    },
    _androidGameVersion (state, args) {
        state.androidGameVersion = args;
        console.log('_androidGameVersion=', state.androidGameVersion);
    },
    _h5GameVersion (state, args) {
        state.h5GameVersion = args;
        console.log('_h5GameVersion=', state.h5GameVersion);
    },
    _windowsGameVersion (state, args) {
        state.windowsGameVersion = args;
        console.log('_windowsGameVersion=', state.windowsGameVersion);
    },
    _iosPackageList (state, args) {
        state.iosPackageList = args;
        console.log('_iosPackageList=', state.iosPackageList);
    },
    _androidPackageList (state, args) {
        state.androidPackageList = args;
        console.log('_androidPackageList=', state.androidPackageList);
    },
    _h5PackageList (state, args) {
        state.h5PackageList = args;
        console.log('_h5PackageList=', state.h5PackageList);
    },
    _windowsPackageList (state, args) {
        state.windowsPackageList = args;
        console.log('_windowsPackageList=', state.windowsPackageList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./website/store/modules/sdk/releasesList.js